import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { orderBy } from "lodash";
import { Collapse, Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";

import DropdownSearch from "../../common/DropdownSearch";
import "./SupportTicketsWidget.scss";

const SupportTicketsFilters = ({
  customers,
  departments,
  users,
  filters,
  onChange,
  onFetch,
  onReset
}) => {
  const customerOptions = useMemo(() => {
    const options =
      customers?.map((customer) => ({
        value: customer._id,
        label: customer.name
      })) || [];
    return orderBy(options, [(option) => option.label.toLowerCase()]);
  }, [customers]);

  const departmentOptions = useMemo(() => {
    const options =
      departments?.map((department) => ({
        value: department._id,
        label: department.description
      })) || [];
    return orderBy(options, [(option) => option.label.toLowerCase()]);
  }, [departments]);

  const userOptions = useMemo(() => {
    const options =
      users?.map((user) => ({
        value: user._id,
        label: user.full_name
      })) || [];
    return orderBy(options, [(option) => option.label.toLowerCase()]);
  }, [users]);

  return (
    <Collapse in>
      <div className="filter-container">
        <Formsy className="vertical form">
          <Row className="mb-0">
            <Col md={3}>
              <DropdownSearch
                isMulti
                placeholder="Assigned Department"
                name="department"
                onChange={onChange}
                value={filters.department}
                data={[...departmentOptions]}
              />
            </Col>
            <Col md={3}>
              <DropdownSearch
                isMulti
                placeholder="Assigned To"
                name="multi_assigned_to"
                onChange={onChange}
                value={filters.multi_assigned_to}
                data={[...userOptions]}
              />
            </Col>
            <Col md={3}>
              <DropdownSearch
                isMulti
                name="customer"
                placeholder="Customer"
                onChange={onChange}
                value={filters.customer}
                data={[...customerOptions]}
              />
            </Col>
            <Col className="mt-1" md={3}>
              <button
                className="btn btn-warning"
                type="button"
                onClick={onReset}
              >
                Reset Filters
              </button>
              <button className="btn btn-info" type="button" onClick={onFetch}>
                Get Tickets
              </button>
            </Col>
          </Row>
        </Formsy>
      </div>
    </Collapse>
  );
};

SupportTicketsFilters.propTypes = {
  customers: PropTypes.array,
  departments: PropTypes.array,
  users: PropTypes.array,
  filters: PropTypes.object,
  onChange: PropTypes.func,
  onFetch: PropTypes.func,
  onReset: PropTypes.func
};

export default SupportTicketsFilters;
